import axiosInstance from "@/api/axiosInstance";
import {
  CancelEventSessionRequest,
  CancelEventSessionResponse,
} from "./types";

export const cancelEventSession = async (
  requestData: CancelEventSessionRequest,
): Promise<CancelEventSessionResponse> => {
  const response = await axiosInstance.post<CancelEventSessionResponse>(
    "/api/private/event-sessions/cancel",
    {
      uuid: requestData.uuid,
      sendNotification: requestData.sendNotification ?? true,
    },
  );

  return response.data;
};
